import { styled } from 'mz-ui-kit'

export const Container = styled('div', ({ $palette, $mobile }) => ({
  fontSize: '12px',
  maxWidth: '350px',
  marginTop: $mobile ? '8px' : '4px',
  textAlign: $mobile ? 'center' : 'left',
  color: `${$palette('TEXT').lighten(40)}`
}));

export const HoldPercentageWrapper = styled('span', {
  fontWeight: 'bold'
});

export const Icon = styled('span', {
  marginRight: '4px'
});
